export default [
  {
    label: 'NAV_SITE_EXPLORE_CTA',
    name: 'whats-on',
    subroutes: [
      {
        label: 'NAV_EXPLORE_EVENTS_CTA',
        name: 'whats-on',
        url: { name: 'whats-on-type', params: { type: 'events' } }
      }, {
        label: 'NAV_EXPLORE_CINEMA_CTA',
        name: 'screenings',
        url: { name: 'whats-on-type', params: { type: 'screenings' } }
      }, {
        label: 'NAV_EXPLORE_FITNESS_CTA',
        name: 'fitness',
        url: { name: 'whats-on-type', params: { type: 'fitness' } }
      }],
    url: { name: 'whats-on-type', params: { type: 'events' } }
  },
  {
    label: 'NAV_SPACES_LABEL',
    name: 'spaces',
    url: { name: 'spaces' }
  },
  {
    label: 'NAV_SITE_PLANNER_CTA',
    name: 'my-planner',
    url: { name: 'my-planner' }
  },
  {
    label: 'NAV_SITE_STAY_CTA',
    name: 'bedrooms',
    url: { name: 'bedrooms' }
  },
  {
    label: 'NAV_SITE_NOTES_CTA',
    name: 'notes',
    url: { name: 'sitecore-jss', params: { route: 'notes' } }
  }
]
